import { HANDLEBARS_REGEX } from "@avenueops/frontend-shared";
import { NotificationType } from "@prisma/client";
import { isValidPhoneNumber } from "libphonenumber-js/max";

export default function validateNotificationInput(value: any, notificationType: any, required = true) {
  if (HANDLEBARS_REGEX.test(value)) {
    // Skip additional RegEx validation for dynamic recipients
    return true;
  }
  switch (notificationType) {
    case NotificationType.SMS:
    case NotificationType.WHATSAPP:
      return required ? value && isValidPhoneNumber(value, "US") : !value || isValidPhoneNumber(value, "US");
    case NotificationType.SLACK:
      const slackRegex = new RegExp(
        "^([#|@]([.a-zA-Z0-9\u00C0-\u00FF_-]+|([a-zA-Z0-9\u00C0-\u00FF_-]*{{[.a-zA-Z0-9\u00C0-\u00FF_-]+}}[a-zA-Z0-9\u00C0-\u00FF_-]*)+)|([C|U|W][A-Z0-9\u00C0-\u00FF]+)|({{[.a-zA-Z0-9\u00C0-\u00FF_-]+}}))$"
      );
      return required ? slackRegex.test(value) : !value || slackRegex.test(value);
    case NotificationType.EMAIL:
      const emailRegex = new RegExp(
        "^((([.a-zA-Z0-9\u00C0-\u00FF_-]+)|({{[a-zA-Z0-9\u00C0-\u00FF_-]+}}))@[.a-zA-Z0-9\u00C0-\u00FF_-]+.[a-zA-Z\u00C0-\u00FF]+)$|^{{[a-zA-Z0-9\u00C0-\u00FF_-]+}}$"
      );
      return emailRegex.test(value);
  }
  return true;
}
